import { content } from "html2canvas/dist/types/css/property-descriptors/content";
import APIAccessor, { ContentType } from "../apiProcessor";
import Constants, { ASSET_API_URL } from "constants/index";

class AssetService {
    protected api: APIAccessor;
    constructor() {
        this.api = new APIAccessor(ASSET_API_URL);
    }

    public uploadImage = async (data: any) => {
        const result = await this.api.post({
            path: Constants.ApiPath.ASSETS.UPLOAD_URL,
            contentType: ContentType.FORM_DATA,
            data
        });
        return result.data.result;
    }
    
}

export default AssetService;